import { render, staticRenderFns } from "./manageRank.vue?vue&type=template&id=142164db&"
import script from "./manageRank.vue?vue&type=script&lang=ts&"
export * from "./manageRank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports